import React from 'react'
import NavigationBar from './NavigationBar'
import Slider from './Slider'
import Cards from './Cards';

import Container from 'react-bootstrap/Container'
import Footer from './Footer';

function Home() {
    return (
        <div>
            <NavigationBar />

            <Container>
                <Slider />
                <br />
                <Cards />
            </Container>

            <Footer />

            
        </div>
    )
}

export default Home
